/**
 * Applies the global options to the engines at boot and whenever they change: volumes and
 * stereo spread to the audio engine, gamma/contrast to the renderer's present pass. (Lighting
 * quality and shadows are read per frame by the game screen.)
 */
import type { AudioEngine } from '../audio/audio';
import type { Renderer } from '../gfx/renderer';
import { type Settings, settings } from './settings';

/** Slider (0..1, 0.5 neutral) → display gamma exponent / contrast factor. */
export function gammaFor(slider: number): number {
  return 0.6 + slider * 0.8;
}
export function contrastFor(slider: number): number {
  return 0.7 + slider * 0.6;
}

export function bindSettings(audio: AudioEngine, renderer: Renderer): void {
  const sound = (s: Settings['sound']) => {
    audio.setVolumes({ sfx: s.sfx, music: s.music });
    audio.separation = s.separation;
  };
  const video = (v: Settings['video']) => {
    renderer.gamma = gammaFor(v.gamma);
    renderer.contrast = contrastFor(v.contrast);
  };
  sound(settings.value.sound);
  video(settings.value.video);
  settings.on('sound', sound);
  settings.on('video', video);
}
